export const WALLET_PAYMENT_METHOD = 'WALLET_PAYMENT_METHOD' as const;
